// DragAndDropHandler — accepts files dropped onto the editor and routes
// each one through UploadStarter. Drag-over is preventDefault'd so the
// browser shows a copy cursor instead of treating the editor as a link
// target.

import { UploadStarter } from "./upload.js"

export class DragAndDropHandler {
  constructor(host) {
    this.element = host.closest("house-md")
  }

  handleDragOver(event) {
    event.preventDefault()
  }

  async handleDrop(event) {
    event.preventDefault()
    for (const item of event.dataTransfer.items) {
      if (item.kind !== "file") continue
      new UploadStarter(this.element, item.getAsFile()).upload()
    }
  }
}
